interface WebService
{
    updateProductCost( product:Product, completion:any) : void ;
    currentStock( products:string[], completion:any ) : void ;
}

WebService.prototype.updateProductCost = function( product:Product, completion:any ) : void
{
    const url_str = this.apiURL + "/entity/" + this.scheme + "/update-product-cost/" + product.identifier;
    let body = { "CostType": product.costType };
    if (product.costProductPrice != null) {
        body["CostProductPrice"] = product.costProductPrice;
     }
    let r = new DLRequest ( url_str, body, "POST" );
    r.execute( completion );
}

WebService.prototype.currentStock = function( products:string[], completion:any ) : void
{
    const url_str = this.scriptURL + "/schema/" + this.scheme + "/python/1_stock_current_summary.py";
    let body = { 
        "filters" : {
            "__report_output_type__":1,
            "session_date": "2025-04-29 00:00:00,2025-04-29 23:59:59",
            "products": products
        }
    };
    let r = new MWSJSONRequest();
    r.initWithURL ( MIOURL.urlWithString( url_str ), body, "POST" );
    r.execute( this, (code:number,data:any) => completion(data, code == 200 ? null : data) );
}


